import LayoutContainer from 'components/Common/LayoutContainer'
import Image from 'components/Common/Image'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import TextButton from 'LuxKit/Button/TextButton'
import SolidSparklesIcon from 'LuxKit/Icons/solid/SolidSparklesIcon'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { FormattedMessage } from 'react-intl'

const ImageContainer = styled(Image)`
  height: ${rem(260)};
  ${mediaQueryUp.tablet} {
    height: ${rem(320)};
  }
  ${mediaQueryUp.desktop} {
    height: ${rem(480)};
  }
`
function TripLandingPageWhyYoullLoveIt() {
  return (
    <Sheet padding="64 0" background="neutral-eight" paletteType="inverse">
      <LayoutContainer>
        <Group direction="vertical" gap={40} horizontalAlign="center">
          <Heading variant="heading2">
            <FormattedMessage
              id="q2uKlI5wMH"
              defaultMessage="Why you'll <i>love it</i>"
              description="Main heading for why you'll love it section"
              values={{
                i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
              }}
            />
          </Heading>
          <Group direction="vertical" gap={64}>
            <Group direction="vertical" gap={24} desktopDirection="horizontal" horizontalAlign="center">
              <ImageContainer
                id="qcetphs298psne6mi4g"
                enhancedFormats={false}
                height={480}
              />
              <Sheet desktopPadding="68 40" padding="0 20">
                <Group direction="vertical" gap={16} desktopGap={20} horizontalAlign="start">
                  <Group direction="vertical" gap={12}>
                    <Heading variant="heading2">
                      <FormattedMessage
                        id="wbA5w1Y8Hk"
                        defaultMessage="Itinerary planning, done all for you"
                        description="Heading for itinerary planning section"
                      />
                    </Heading>
                    <BodyText variant="large">
                      <FormattedMessage
                        id="garF22qvNo"
                        defaultMessage="No more starting from scratch. Just tell us what kind of trip you're after, and TripPlanner instantly builds a personalised itinerary, crafted to match your interests, pace, and travel style.{br}{br}From where to stay to what to eat, see, and do, everything is covered for you, effortlessly."
                        description="Description for itinerary planning section"
                        values={{
                          br: <br />,
                        }}
                      />
                    </BodyText>
                  </Group>
                  <TextButton kind="secondary" size="large" startIcon={<SolidSparklesIcon />} shape="round" to="/trip-planner/generate-trip" fit="mobile-full-width">
                    <FormattedMessage
                      id="rLRekaA+MD"
                      defaultMessage="Start planning - It's free"
                      description="Button text to start planning"
                    />
                  </TextButton>
                </Group>
              </Sheet>
            </Group>
            <Group direction="vertical" gap={24} desktopDirection="horizontal" horizontalAlign="center">
              <CSSBreakpoint max="tablet">
                <ImageContainer
                  id="e33ubeatjqhrjswefxcm"
                  enhancedFormats={false}
                  height={480}
                />
              </CSSBreakpoint>
              <Sheet desktopPadding="68 40" padding="0 20">
                <Group direction="vertical" gap={16} desktopGap={20} horizontalAlign="start">
                  <Group direction="vertical" gap={12}>
                    <Heading variant="heading2">
                      <FormattedMessage
                        id="M5Ub+8qpft"
                        defaultMessage="Dream, plan & book in one place"
                        description="Heading for dream, plan and book section"
                      />
                    </Heading>
                    <BodyText variant="large">
                      <FormattedMessage
                        id="Iudxuq4AmG"
                        defaultMessage="TripPlanner lets you save ideas for later, plan when you're ready, and book when the time is right. From flights, hotels, tours, cruises, car hire and local experiences, you can browse and book every item directly within your itinerary.{br}{br}No more juggling apps, tabs or tools. Just one seamless space to bring your trip to life."
                        description="Description for dream, plan and book section"
                        values={{
                          br: <br />,
                        }}
                      />
                    </BodyText>
                  </Group>
                  <TextButton kind="secondary" size="large" startIcon={<SolidSparklesIcon />} shape="round" to="/trip-planner/generate-trip" fit="mobile-full-width">
                    <FormattedMessage
                      id="rLRekaA+MD"
                      defaultMessage="Start planning - It's free"
                      description="Button text to start planning"
                    />
                  </TextButton>
                </Group>
              </Sheet>
              <CSSBreakpoint min="desktop">
                <ImageContainer
                  id="e33ubeatjqhrjswefxcm"
                  enhancedFormats={false}
                  height={480}
                />
              </CSSBreakpoint>
            </Group>
            <Group direction="vertical" gap={24} desktopDirection="horizontal" horizontalAlign="center">
              <ImageContainer
                id="viwdp341xm5wzfmgez7"
                enhancedFormats={false}
                height={480}
              />
              <Sheet desktopPadding="68 40" padding="0 20">
                <Group direction="vertical" gap={16} desktopGap={20} horizontalAlign="start">
                  <Group direction="vertical" gap={12}>

                    <Heading variant="heading2">
                      <FormattedMessage
                        id="3zrkj6cTyM"
                        defaultMessage="Booked elsewhere? No problem"
                        description="Heading for booked elsewhere section"
                      />
                    </Heading>
                    <BodyText variant="large">
                      <FormattedMessage
                        id="RYTgHvpeDS"
                        defaultMessage="Simply forward any email to TripPlanner and it will automatically add it to your itinerary and organise it into one seamless timeline.{br}{br}You'll never need to search your inbox for booking confirmations again!"
                        description="Description for booked elsewhere section"
                        values={{
                          br: <br />,
                        }}
                      />
                    </BodyText>
                  </Group>
                  <TextButton kind="secondary" size="large" startIcon={<SolidSparklesIcon />} shape="round" to="/trip-planner/generate-trip" fit="mobile-full-width">
                    <FormattedMessage
                      id="rLRekaA+MD"
                      defaultMessage="Start planning - It's free"
                      description="Button text to start planning"
                    />
                  </TextButton>
                </Group>
              </Sheet>
            </Group>
          </Group>
          <Group direction="vertical" gap={24} desktopDirection="horizontal" horizontalAlign="center">
            <CSSBreakpoint max="tablet">
              <ImageContainer
                id="yibrz2eoyvzbmayj1s3g"
                enhancedFormats={false}
                height={480}
              />
            </CSSBreakpoint>
            <Sheet desktopPadding="68 40" padding="0 20">
              <Group direction="vertical" gap={16} desktopGap={20} horizontalAlign="start">
                <Group direction="vertical" gap={12}>
                  <Heading variant="heading2">
                    <FormattedMessage
                      id="mv4dul3qiW"
                      defaultMessage="Change of plans? No worries"
                      description="Heading for change of plans section"
                    />
                  </Heading>
                  <BodyText variant="large">
                    <FormattedMessage
                      id="K16D4CtvBs"
                      defaultMessage="TripPlanner makes it easy to edit on the go. Rearrange your day, move bookings, or regenerate your plan with a click.{br}{br}It's the flexibility you need, without the frustration."
                      description="Description for change of plans section"
                      values={{
                        br: <br />,
                      }}
                    />
                  </BodyText>
                </Group>
                <TextButton kind="secondary" size="large" startIcon={<SolidSparklesIcon />} shape="round" to="/trip-planner/generate-trip" fit="mobile-full-width">
                  <FormattedMessage
                    id="rLRekaA+MD"
                    defaultMessage="Start planning - It's free"
                    description="Button text to start planning"
                  />
                </TextButton>
              </Group>
            </Sheet>
            <CSSBreakpoint min="desktop">
              <ImageContainer
                id="yibrz2eoyvzbmayj1s3g"
                enhancedFormats={false}
                height={480}
              />
            </CSSBreakpoint>
          </Group>
          <Group direction="vertical" gap={24} desktopDirection="horizontal" horizontalAlign="center">
            <ImageContainer
              id="rnsx6dl5vnwy4na60i5u"
              enhancedFormats={false}
              height={480}
            />
            <Sheet desktopPadding="68 40" padding="0 20">
              <Group direction="vertical" gap={16} desktopGap={20} horizontalAlign="start">
                <Group direction="vertical" gap={12}>
                  <Heading variant="heading2">
                    <FormattedMessage
                      id="idHacNSczu"
                      defaultMessage="Plan together, stay in sync"
                      description="Heading for plan together section"
                    />
                  </Heading>
                  <BodyText variant="large">
                    <FormattedMessage
                      id="B/RGHNU8TW"
                      defaultMessage="Invite others to view or edit your trip. Everyone can collaborate in real time, see the latest plans, and share the excitement without the messy group chats."
                      description="Description for plan together section"
                    />
                  </BodyText>
                </Group>
                <TextButton kind="secondary" size="large" startIcon={<SolidSparklesIcon />} shape="round" to="/trip-planner/generate-trip" fit="mobile-full-width">
                  <FormattedMessage
                    id="rLRekaA+MD"
                    defaultMessage="Start planning - It's free"
                    description="Button text to start planning"
                  />
                </TextButton>
              </Group>
            </Sheet>
          </Group>

        </Group>
      </LayoutContainer>
    </Sheet>
  )
}

export default TripLandingPageWhyYoullLoveIt
